import { createFileRoute } from '@tanstack/react-router';
import { RequireSignedIn } from '../app/layouts/guards';
import { OexArea } from '../app/theme';
import { LobbyPage } from '../features/tenancy';

/** Lobby: signed-in users without an active membership; branded `.theme-oex`. */
export const Route = createFileRoute('/lobby')({
  component: () => (
    <RequireSignedIn>
      <OexArea>
        <LobbyPage />
      </OexArea>
    </RequireSignedIn>
  ),
});
